import { Home, ShieldOff } from "lucide-react";
import { useNavigate } from "react-router";
import { GLOBAL_FORBIDDEN_ACCESS_ERROR_MESSAGE, GLOBAL_FORBIDDEN_ERROR_DESCRIPTION } from "@/shared/configs/globalErrors.config";
import { Button } from "@/shared/ui/Button";

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  const handleRedirect = () => navigate("/");
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12 text-center">
      <ShieldOff
        size={68}
        className="text-orange-500 mb-6"
      />

      <h1 className="text-5xl font-extrabold text-gray-900 mb-4">403</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-2">Accès refusé</h2>
      <p className="text-gray-500 max-w-md mb-6 text-balance flex flex-col items-center justify-center">
        <span>{GLOBAL_FORBIDDEN_ACCESS_ERROR_MESSAGE}</span>
        <span>{GLOBAL_FORBIDDEN_ERROR_DESCRIPTION}</span>
      </p>

      <Button
        onClick={handleRedirect}
        variant="actionGhost"
      >
        <Home className="size-4 shrink-0" />
        Retour au tableau de bord
      </Button>
    </div>
  );
};

export default AccessDeniedPage;
